import {utils} from"./utils.js"
import $ from "./jq.js"

(function(){
    
    var e = "http://newgame.holyfinger.com:8083/api/";
    window.location.href.indexOf("https") >= 0 && (e = e.replace("http://newgame.holyfinger.com:8083", "https://newgame.holyfinger.com"))
    var loading = true
    var isExpanded = false
    var valParams = utils.n("searchTxt")
    $(document).ready(function(){
        
        $(".ipt-search").change(function(e){
            valParams = e.target.value;
            searchIpt()
        })
       
        $(".ipt-search").focus().val(valParams)
        $(".h-bg").click(function(){
            window.location.href="./index.html"
        })
        $(".item-l-4").hide()
        $(".btn-close").click(function(){
            $(".ipt-search").val("")
            $(".search").css("padding","0.2rem 0.1rem").css("min-height","auto")
            $(".list-search").empty()
            $(".no-search").show()
            $(".popular").show()
            $(".list-search").css("min-height","auto")
        })
        utils.t({
            url: e + "ogame",
            type: "post",
            data: JSON.stringify({
                "channel":"crazegame",
                type: "Hot Games",
                page:1
            }),
            timeout: 5e3,
            error: function() {},
            success: function(d) {
                var  cardNode = $(".card")
                try {
                    if (d) {
                        var n = JSON.parse(d),
                            t = n.data,
                            l= t.splice(0,1),
                            gameList = t.splice(0,2),
                            gameList2 = t.splice(0,3),
                            ss="",
                            gameTxt="";
                            cardNode.find(".title>a").attr("href",'/more.html?type=Hot Games')
                            cardNode.find(".lt>a").attr("href",'/info.html?id='+l[0].id)
                            cardNode.find(".img1").attr("src",l[0].gamelogo)
                            cardNode.find(".txt").text(l[0].gamename)
                            gameList.map(e=>{
                                gameTxt+='<a href="info.html?id=' + e.id + '"><img alt="" src="' + (e.gamelogo||'./images/default.png') + '" /><p><span class="txt">'+e.gamename+'</span></p></a>'
                            })
                            cardNode.find(".rt").html(gameTxt)
                            gameList2.map(e => {
                                ss += '<div class="item"><a href="info.html?id=' + e.id + '"><img alt="" src="' + (e.gamelogo||'./images/default.png') + '" /></a><p><span class="txt">'+e.gamename+'</span></p></div>'
                            })
                            cardNode.find(".box-game").html(ss);
                    }
                } catch {}
            }
        })
        function searchIpt()
        {
            if(valParams.length==0)
            {
                $(".no-search").text("NO GAMES WAS FOUND").show()
                $(".search").css("min-height","auto").show()
                $(".list-search").hide()
                $(".empty-search").show().css("min-height","29vh")
                return false
            }
            utils.t({
                url: e + "gamesearch",
                type: "post",
                data: JSON.stringify({ 
                    "channel": "crazegame",
                    "name":valParams
                }),
                timeout: 5e3,
                error: function() {},
                success: function(e) {
                    $(".list-search").empty()
                    try {
                        if (e) {
                            var n = JSON.parse(e),
                            t = n.data,
                            rtxt= "",
                            ss=""; 
                            if(t.length==0)
                            {
                                $(".popular").show()
                                $(".search").show();
                                $(".no-search").text("NO GAMES WAS FOUND").show()
                                $(".list-search").css("min-height","auto")
                                return false
                            }
                            else
                            {
                                $(".popular").hide()
                                $(".no-search").hide()
                                $(".list-search").show()
                                if(t.length<=12)
                                {
                                    $(".list-search").css("min-height","56vh")
                                }
                            }
                            t.map(e => {
                                ss += '<div class="item"><a href="info.html?id=' + e.id + '"><img alt="" src="' + (e.gamelogo||'./images/default.png') + '" /></a><p><span class="txt">'+e.gamename+'</span></p></div>'
                            }), $(".list-search").html(ss);
                          
                        }
                    } catch {}
                }
            })
        }
        searchIpt()
    })

})()